/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnedisConnectionConfigUpdate } from '../../models/enedis-connection-config-update';

export interface UpdateEnedisConnectionConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected enedis connection configuration
 */
  enedisUid: string;
  
    /**
     * The Enedis connection update object
     */
    body: EnedisConnectionConfigUpdate
}

export function updateEnedisConnectionConfiguration(http: HttpClient, rootUrl: string, params: UpdateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateEnedisConnectionConfiguration.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('enedisUid', params.enedisUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateEnedisConnectionConfiguration.PATH = '/stations/{uid}/enedis/{enedisUid}';
